import React from 'react';
import PropTypes from 'prop-types';
import ProductSearch from '../../../ProductSearch';

const SkuFilter = ({ onChange, operator, settings, suggestions, value, ...props }) => {
  const multiple = !operator || ['in', 'not_in'].includes(operator);

  const handleChange = (ev, selected) => {
    if (onChange && typeof onChange === 'function') {
      const values = (selected ?? []).reduce((acc, selectedValue) => {
        if (typeof selectedValue === 'object') {
          return [...acc, selectedValue?.sku];
        }

        if (selectedValue) {
          return [...acc, selectedValue];
        }

        return acc;
      }, []);

      onChange(ev, values);
    }
  };

  return (
    <ProductSearch
      {...props}
      onChange={handleChange}
      value={multiple ? value ?? [] : value}
      multiple={multiple}
      enableCreate
    />
  );
};

SkuFilter.propTypes = {
  onChange: PropTypes.func,
  operator: PropTypes.string,
  settings: PropTypes.object,
  suggestions: PropTypes.array,
  value: PropTypes.array,
};

SkuFilter.defaultProps = {
  onChange: undefined,
  operator: undefined,
  settings: {},
  suggestions: [],
  value: [],
};

export default SkuFilter;
